/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";

export interface Column {
  header: string;
  key?: string;
  render?: (row: any, index: number) => React.ReactNode;
  className?: string;
}

interface MediaPrepTableProps {
  columns: Column[];
  data: any[];
  emptyMessage: string;
}

const MediaPrepTable: React.FC<MediaPrepTableProps> = ({ columns, data, emptyMessage }) => {
  return (
    <div className="overflow-x-auto overflow-y-auto max-h-[340px]">
      <table className="min-w-max text-left border-collapse">
        <thead>
          <tr className="bg-slate-50/50 text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] border-b border-slate-100 whitespace-nowrap">
            {columns.map((col, i) => (
              <th key={i} className={`px-5 py-3 ${col.className || ""}`}>
                {col.header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-50">
          {data?.length > 0 ? (
            data.map((row, i) => (
              <tr key={i} className="hover:bg-slate-50/50 transition-colors text-sm">
                {columns.map((col, j) => (
                  <td key={j} className={`px-5 py-3 ${col.className || ""}`}>
                    {col.render ? col.render(row, i) : col.key ? row[col.key] : "-"}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center py-4 text-slate-400">
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default MediaPrepTable;